/*global $ */

$(document).ready(function () {
  if (window.location.hash.substr(1) === 'edit' && $('.editable').length > 0) {
    var view = new EditBlogPostView({el: $('#editForm')});
    view.loadEditInterface();
  }
});
